export default __webpack_public_path__ + "static/media/waving.dea8561b.gif";